module.exports = __webpack_public_path__ + "static/media/me1.47fa56e9.jpg";